/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Session profile tokens (LOCAL_USER_PROFILE, LOCAL_NETWORK_PROFILE) provide
 * cycle-safe aliases for LocalUserProfile / LocalNetworkProfile.
 */
import {LOCAL_NETWORK_PROFILE, LOCAL_USER_PROFILE} from '../components/session/session-profile.tokens';
import {LocalUserProfile} from '../components/session/local-user-profile';
import {LocalNetworkProfile} from '../components/session/local-network-profile';

export const localUserProfileTokenProvider = {
  provide: LOCAL_USER_PROFILE,
  useExisting: LocalUserProfile
};

export const localNetworkProfileTokenProvider = {
  provide: LOCAL_NETWORK_PROFILE,
  useExisting: LocalNetworkProfile
};
